import { render, staticRenderFns } from "./SettingsTabGroups.vue?vue&type=template&id=2d33effc"
import script from "./SettingsTabGroups.vue?vue&type=script&lang=js"
export * from "./SettingsTabGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports